export enum SofaCamaType {
  EXTENSIBLE = 'Extensible',
  RECLINABLE = 'Reclinable'
}
